import { StyleEnums } from "models/enums";

const SizingHelper = {
  isSmallScreen: (): boolean => {
    return window.innerWidth <= 1280;
  },

  onWindowWidthChange: (): StyleEnums.WindowSizes => {
    let currentWindowSize: StyleEnums.WindowSizes;

    if (window.innerWidth <= 600) {
      currentWindowSize = "xs";
    } else if (window.innerWidth <= 900) {
      currentWindowSize = "sm";
    } else if (window.innerWidth <= 1280) {
      currentWindowSize = "md";
    } else if (window.innerWidth <= 1584) {
      currentWindowSize = "lg";
    } else if (window.innerWidth <= 1920) {
      currentWindowSize = "xl";
    } else {
      currentWindowSize = "xxl";
    }

    return currentWindowSize;
  },
};

export default SizingHelper;
